module.exports = __webpack_public_path__ + "img/STAR SHADES BW.b19bcc9.svg";